import { render, staticRenderFns } from "./StatsComponent.vue?vue&type=template&id=79920ee8&scoped=true"
import script from "./StatsComponent.vue?vue&type=script&lang=js"
export * from "./StatsComponent.vue?vue&type=script&lang=js"
import style0 from "./StatsComponent.vue?vue&type=style&index=0&id=79920ee8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79920ee8",
  null
  
)

export default component.exports